import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import AssigneePicker from "./AssigneePicker";
import { STATUS_META, PRIORITY_META } from "./ui-bits";

export default function TaskFormFields({ status, onStatus, priority, onPriority, startDate, onStartDate, dueDate, onDueDate, dueTime, onDueTime, users, assignees, onToggleAssignee }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <Select value={status} onValueChange={onStatus}>
          <SelectTrigger data-testid="task-status-select" className="h-8 text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(STATUS_META).map(([k, m]) => <SelectItem key={k} value={k} data-testid={`status-option-${k}`}>{m.label}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={priority} onValueChange={onPriority}>
          <SelectTrigger data-testid="task-priority-select" className="h-8 text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(PRIORITY_META).map(([k, m]) => <SelectItem key={k} value={k} data-testid={`priority-option-${k}`}>{m.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Start date</p>
          <input data-testid="task-start-date-input" type="date" value={startDate || ""} onChange={(e) => onStartDate(e.target.value)}
            className="w-full h-8 px-3 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Due date</p>
          <input data-testid="task-due-date-input" type="date" value={dueDate || ""} onChange={(e) => onDueDate(e.target.value)}
            className="w-full h-8 px-3 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Due time</p>
          <input data-testid="task-due-time-input" type="time" value={dueTime || ""} onChange={(e) => onDueTime(e.target.value)}
            className="w-full h-8 px-3 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
        </div>
      </div>
      <AssigneePicker users={users} selected={assignees} onToggle={onToggleAssignee}
        testid="task-assignees-select" menuTestid="task-assignees-menu" optionPrefix="assignee-option" fullWidth />
    </>
  );
}
